export default [
  {
    OPT_CLAS_CD: 'OPT00001',
    OPT_CLAS_NM: '추가',
    OPT_CLAS_KO_NM: '추가',
    OPT_CLAS_JP_NM: '追加',
    OPT_CLAS_EN_NM: 'Plus',
    OPT_CLAS_CN_NM: '',
    OPT_CLAS_TW_NM: '',
    OPT_CLAS_TYPE: '',
    OPT_ORDER: 1,
    OPT_MULTI_USE_YN: 'Y',
    OPT_URPC: 0,
    IMG_YN: 'N',
    OPT_GRP_CD: '001',
    OPT_GBN: '01',
  },
];
